import { render, staticRenderFns } from "./UntagForm.vue?vue&type=template&id=77684756"
import script from "./UntagForm.vue?vue&type=script&lang=js"
export * from "./UntagForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports